import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { escapeRegexCharacters } from "../../helpers/formHelper"

const HotelNameField = ({ filters, setFilters, onSubmit }) => {

  const [name, setName] = useState(filters.hotelName)
  const nameRef         = useRef()

  const __handleOnChange = (e) => {
    let value = e.currentTarget.value
    value = escapeRegexCharacters(value)
    setName(value)
    __setHotelName(value)
  }

  useEffect(() => {
    if( nameRef ) {
      nameRef.current.addEventListener("keyup", _handleEnter)
    }

    return () => {
      if(nameRef) {
        nameRef.current.removeEventListener("keyup", _handleEnter)
      }
    }
  }, [])

  const _handleEnter = function(e) {
    if (e.key === "Enter") onSubmit()
  }

  useEffect(() => {
    if(filters.hotelName !== name ) {
      setName(filters.hotelName)
    }
  }, [filters.hotelName])

  const __setHotelName = (value) => {
    let tmp = {...filters}
    tmp.hotelName = value
    setFilters(tmp)
  }

  return (
    <label className="hotel-name" htmlFor="hotel_name">
      <i className="fas fa-hotel main-icon" />
      <input
        type        = "text"
        name        = "hotel_name"
        value       = { name }
        onChange    = {__handleOnChange}
        className   = "hotel-name-field"
        placeholder = "eg. Hilton"
        minLength   = { 3 }
        ref         = { nameRef }
        />
    </label>
  )
}

HotelNameField.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default HotelNameField
